<template>
  <section class="features-wrapper">
    <div class="features-container">
      <div class="feature-card" v-for="(item, index) in features" :key="index">
        <!-- 将文字全部放入六边形卡片内部 -->
        <div class="hex-content">
          <div class="hex-icon">🛡️</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      features: [
        { title: 'Fund Tracing', desc: 'Blockchain forensics analysis' },
        { title: 'Fast Investigation', desc: 'Expedited case processing' },
        { title: 'Privacy Secured', desc: 'Encrypted confidential handling' },
        { title: 'Transparent Updates', desc: 'Regular case progress reports' },
        { title: 'Government Certified', desc: 'Officially registered firm' }
      ]
    };
  }
}
</script>

<style scoped>
.features-wrapper {
  padding: 0 5% 100px;
}

.features-container {
  background: transparent;
  border-radius: 20px;
  padding: 60px 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 30px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  flex-wrap: wrap;
}

/* 卡片容器：带弹动效果 */
.feature-card {
  max-width: 180px;
  width: 100%;
  /* 弹性动画曲线：鼠标放上去会有明显弹起再落下的效果 */
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.4s ease;
  cursor: pointer;
}

.feature-card:hover {
  /* 弹起动作 */
  transform: translateY(-10px) scale(1.05);
  filter: drop-shadow(0 10px 20px rgba(46, 230, 168, 0.3));
}

/* 六边形背景和容器 */
.hex-content {
  width: 100%;
  height: 180px;
  background: #121a2b;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  flex-direction: column;
  /* 文字从上一个下依次排列 */
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px 10px;
  box-sizing: border-box;
}

/* 图标 */
.hex-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

/* 标题和描述（在内部排列） */
.hex-content h3 {
  font-size: 1.1rem;
  margin: 0 0 8px;
  color: #fff;
  font-weight: 600;
}

.hex-content p {
  font-size: 0.85rem;
  color: #a0b3cc;
  line-height: 1.4;
  margin: 0;
}

@media (max-width: 900px) {
  .features-container {
    gap: 40px;
  }
}
</style>